import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import ReportCardSkeleton from './ReportCardSkeleton';

interface ReportCategorySectionSkeletonProps {
  cardCount?: number;
}

export function ReportCategorySectionSkeleton({ cardCount = 2 }: ReportCategorySectionSkeletonProps) {
  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <Skeleton variant="text" width={150} height={32} />
        <Skeleton variant="circular" width={24} height={24} />
      </Stack>
      <Grid container spacing={2}>
        {Array.from({ length: cardCount }).map((_, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 4 }}>
            <ReportCardSkeleton />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ReportCategorySectionSkeleton;
